import i18n from "@/boot/i18n";

const iEmptyData = (data, emptyData = 'na') => {
  try {
    if ((Array.isArray(data) && !data.length) || (!data.trim()) || data === null || data === 'null' || data === undefined || data === "undefined") {
      return i18n.t(`common.${emptyData}`)
    }
    return data
  } catch (e) {
    return data
  }
}

export {
  iEmptyData,
}
